import { render, staticRenderFns } from "./PriceSetup.vue?vue&type=template&id=1b07bf79&scoped=true"
import script from "./PriceSetup.vue?vue&type=script&lang=js"
export * from "./PriceSetup.vue?vue&type=script&lang=js"
import style0 from "./PriceSetup.vue?vue&type=style&index=0&id=1b07bf79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b07bf79",
  null
  
)

export default component.exports